import React from 'react';
import BannerWrap from "./style/pink";
import Container from "../../components/paper/container";
import SectionTitle from "../../components/heading/section";
import P1 from "../../components/paragraph";

const Banner = () => {
    return (
        <BannerWrap>
            <Container>
                <SectionTitle style={{width: '100%', paddingTop: '0px', paddingBottom: '-100px'}}>
                No More Filling Applications, Paying Fees, Providing ID
                </SectionTitle>
            </Container>
        </BannerWrap>
    );
};

export default Banner;
